import { defineStore } from 'pinia'
import axios from 'axios'

export const useHotspotStore = defineStore('hotspot', {
  state: () => ({
    stats: { total: 0, regular: 0, fuxiangsan: 0, bulk: 0 },
    timer: null
  }),
  actions: {
    async fetchStats() {
      try {
        const token = localStorage.getItem('token')
        const res = await axios.get('/api/v1/admin/hotspotStats', {
          headers: { Authorization: token }
        })
        if (res.data && res.data.code === '200' && res.data.data) {
          this.stats = {
            total: res.data.data.total || 0,
            regular: res.data.data.regular || 0,
            fuxiangsan: res.data.data.fuxiangsan || 0,
            bulk: res.data.data.bulk || 0
          }
        }
      } catch (err) {
        console.error('拉取热点统计失败', err)
      }
    },

    startPolling() {
      if (this.timer) return
      this.fetchStats()
      this.timer = setInterval(() => {
        this.fetchStats()
      }, 1 * 60 * 1000)
    },

    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}) 